import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';

import { AngularFirestore } from '@angular/fire/compat/firestore';

import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ApiBoardThread } from '../../api-client-module';

import { MessageDialogComponent } from '../../common/message-dialog/message-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface boardThreadDialogData {
  boardThread?: ApiBoardThread,
  isBrowse: boolean;
}

@Component({
  selector: 'app-board-thread-dialog',
  templateUrl: './board-thread-dialog.component.html',
  styleUrls: ['./board-thread-dialog.component.css'],
  standalone: false,
})
export class BoardThreadDialogComponent implements OnInit {

  @ViewChild('fileInput1') fileInput1!: ElementRef;
  @ViewChild('fileInput2') fileInput2!: ElementRef;

  boardThread?: any;
  isBrowse: boolean = false;
  isAdded: boolean = false;

  boardThreadFormGroup!: FormGroup;
  threadNameControl!: FormControl;
  threadDescControl!: FormControl;

  //  マウスホバー時の変化
  isHovering: boolean = false;
  //  画像ファイル
  image_file: File = null as any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BoardThreadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boardThreadDialogData,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.boardThread = this.data.boardThread;
    this.isBrowse = this.data.isBrowse!;
    if (!this.boardThread) {
      this.boardThread = {
        thread_name: '',
        thread_desc: '',
        thread_image: null as any,
        thread_owner: ''
      };
      this.isAdded = true;
    }
    this.createForm();
    this.threadNameControl = this.boardThreadFormGroup.get('threadName') as FormControl;
    this.threadDescControl = this.boardThreadFormGroup.get('threadDesc') as FormControl;
  }

  public getErrorMessageToThreadName() {
    return this.threadNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToThreadDesc() {
    return this.threadDescControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  private createForm() {
    this.boardThreadFormGroup = this.formBuilder.group(
      {
        threadName: [this.boardThread!.thread_name, [Validators.required]],
        threadDesc: [this.boardThread!.thread_desc, [Validators.required]],
      }
    );
  }

  addThread(): void {
    if (this.boardThreadFormGroup.valid) {
      this.boardThread!.thread_name = this.threadNameControl.value;
      this.boardThread!.thread_desc = this.threadDescControl.value;
      this.boardThread['file'] = this.image_file;
      this.dialogRef.close(this.boardThread);
    }
  }

  updThread(): void {
    if (this.boardThreadFormGroup.valid) {
      this.boardThread!.thread_name = this.threadNameControl.value;
      this.boardThread!.thread_desc = this.threadDescControl.value;
      this.boardThread['file'] = this.image_file;
      this.boardThread['isDelete'] = false;
      this.dialogRef.close(this.boardThread);
    }
  }

  delThread(): void {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '500px',
      height: '180px',
      disableClose: true,
      data: {
        message: this.translate.instant('スレッドを削除します。よろしいですか？　注）スレッドに投稿されたコメントも削除されます。')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        if (this.boardThreadFormGroup.valid) {
          this.boardThread!.thread_name = this.threadNameControl.value;
          this.boardThread!.thread_desc = this.threadDescControl.value;
          this.boardThread['file'] = this.image_file;
          this.boardThread['isDelete'] = true;
          this.dialogRef.close(this.boardThread);
        }
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onChangeFile1Input(event: Event) {
    this.image_file = null as any;
    const target = event.target as HTMLInputElement;
    if (target.files!.length > 0) {
      this.image_file = target.files!.item(0)!;
    }
  }

  onChangeFile2Input(event: Event) {
    this.image_file = null as any;
    const target = event.target as HTMLInputElement;
    if (target.files!.length > 0) {
      this.image_file = target.files!.item(0)!;
    }
  }

  onFile1ClearClick() {
    this.image_file = null as any;
    this.fileInput1.nativeElement.value = "";
  }

  onFile2ClearClick() {
    this.image_file = null as any;
    this.fileInput2.nativeElement.value = "";
  }

  onImageClearClick() {
    this.image_file = null as any;
    this.boardThread.thread_image = null;
  }
}
